import { JobTypeAPI } from '@business/api/tm_job_type';
import { JobTypeId, TmJobTypeResponse } from '@business/entities/tm';
import { handleMessage, requestMessage } from '@business/messages';
import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { showDeleteConfirmation } from '@modules/common';
import { switchMap, tap } from 'rxjs/operators';

export class JobTypeBloc extends BaseBloc {
  private readonly itemRepo = new Repository<TmJobTypeResponse>({
    getItemId: term => term.id,
  });

  readonly items$ = this.itemRepo.items$;
  readonly selectTemplate = this.itemRepo.selectItem;

  onReset() {
    this.itemRepo.reset();
  }

  fetchJobTypes = () => {
    return JobTypeAPI.fetchJobTypes().pipe(this.itemRepo.ops.reset(), handleMessage({ error: requestMessage('fetch_job_type_error') }));
  };

  fetchJobType = (id: JobTypeId) => {
    return JobTypeAPI.fetchJobType(id).pipe(
      this.itemRepo.ops.upsertOne(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_job_type_error') }),
    );
  };

  createJobType = (type: string) => {
    return JobTypeAPI.createJobType(type).pipe(
      this.itemRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_job_type'),
      }),
    );
  };

  updateJobType = (id: JobTypeId, type: string) => {
    return JobTypeAPI.updateJobType(id, type).pipe(
      this.itemRepo.ops.upsertOne(item => ({ item })),
      handleMessage({
        type: requestMessage('update_job_type'),
      }),
    );
  };

  deleteJobType = (id: JobTypeId) => {
    return showDeleteConfirmation('Delete Term', `Do you really want to remove this job type?`).pipe(
      switchMap(() => JobTypeAPI.deleteJobType(id)),
      this.itemRepo.ops.removeOne(() => id),
      handleMessage({
        type: requestMessage('delete_job_type'),
      }),
    );
  };
}
